import React, { useState, useEffect, useRef, useContext } from 'react'
import { Row, Menu } from 'antd'
import { getCookie, removeCookieAll } from 'helper/cookie'
import projectlistwhite from '../../../icons/sidebar/projectlistwhite.svg'
import taskinboxwhite from '../../../icons/sidebar/taskinboxwhite.svg'
import proskill2 from '../../../icons/sidebar/proskill-2.svg'
import adminwhite from '../../../icons/sidebar/adminwhite.svg'
import analyticswhite from '../../../icons/sidebar/analyticswhite.svg'
import historyIconwhite from '../../../icons/sidebar/historywhite.svg'
import logoutIconWhite from '../../../icons/sidebar/logout.svg'
import summary_white from '../../../icons/sidebar/summary_white.svg'
import { UserActionTypes } from '../../../redux/user/user.types'

import projectlistBlue from '../../../icons/sidebar/projectlistblue.svg'
import taskinboxBlue from '../../../icons/sidebar/taskinboxblue.svg'
import proskillBlue from '../../../icons/sidebar/proskill-2 Blue.svg'
import adminBlue from '../../../icons/sidebar/adminBlue.svg'
import analyticsBlue from '../../../icons/sidebar/analyticsBlue.svg'
import historyIconBlue from '../../../icons/sidebar/historyblue.svg'
import summaryBlue from 'icons/sidebar/summary_Blue.svg'
import CallCenterIconWhite from 'icons/sidebar/CallCenterIconWhite.svg'
import CallCenterIconBlue from 'icons/sidebar/CallCenterIconBlue.svg'



import styled from 'styled-components'
import { Link, useHistory } from 'react-router-dom'
import '../../../styleLess/signature/sidebar.scss'
import ModalSaveChange from 'common/Project/modalSaveChange'
import {
  DollarOutlined,
  ControlOutlined,
  FolderOpenOutlined,
  CalendarOutlined,
  AimOutlined,
  ToolOutlined,
  DashboardOutlined,
  ShopOutlined,
  ShoppingOutlined,
  StarOutlined,
  IdcardOutlined,
  ScheduleOutlined,
  AuditOutlined,
  FormOutlined,
  RightOutlined,
  DownOutlined,
  LeftOutlined,
  ProductOutlined,
} from '@ant-design/icons'
import lang from 'lang/en'
import _refiner from 'refiner-js'

const SliderWrapper = styled.div``
const Minimenu = styled.div``
const DESKTOP_BREAKPOINT = 800
const MINI_RAIL_WIDTH = 72

//checkrole
import { CounterContext } from 'redux/Golbalvalues'
import { logoutUser } from 'redux/user/user.action'
import {
  LOGIN_AXONS_ONE,
  MENU_HISTORY_VISIBLE,
  MENU_INBOX_VISIBLE,
  MENU_PROFESSIONAL_SKILL_VISIBLE,
} from 'config/env'
import { useDispatch } from 'react-redux'

const CustomSlider = (props) => {
  const { toggle, isMobielView, useMargin, collapsed, onAutoClose, onAutoOpen } = props
  const language = getCookie('lang')
  const word = lang[language]
  const history = useHistory()
  const pathName = history.location.pathname
  const [sildOpen, setSildOpen] = useState(
    () => window.innerWidth > DESKTOP_BREAKPOINT && !collapsed,
  )
  const [narrow, setNarrow] = useState(() => window.innerWidth <= DESKTOP_BREAKPOINT)
  const preferMiniRef = useRef(collapsed)
  const collapsedSeenRef = useRef(collapsed)
  const syncingNarrowCloseRef = useRef(false)
  const {
    mainRoleUser,
    adminPermission,
    getPermissionAdmin,
    setPathActive,
    pathActive,
    isDirty,
    click_path,
    setClick_path,
    form,
  } = useContext(CounterContext)
  const dispatch = useDispatch()

  // จัดการ menuEvent สำหรับ submenu (แยกจาก sildOpen)
  const [menuEvent, setMenuEvent] = useState(window.innerWidth > DESKTOP_BREAKPOINT)

  useEffect(() => {
    const userToggled = collapsedSeenRef.current !== collapsed
    collapsedSeenRef.current = collapsed
    if (syncingNarrowCloseRef.current) {
      syncingNarrowCloseRef.current = false
      return
    }
    if (window.innerWidth <= DESKTOP_BREAKPOINT) {
      if (userToggled) setSildOpen((open) => !open)
      return
    }
    preferMiniRef.current = collapsed
    setSildOpen(!collapsed)
  }, [collapsed])

  useEffect(() => {
    if (sildOpen) {
      useMargin(narrow ? 0 : 264, false)
    } else if (!narrow) {
      useMargin(MINI_RAIL_WIDTH, true)
    } else {
      useMargin(0, true)
    }
  }, [sildOpen, narrow, useMargin])

  const closeNarrowSidebar = () => {
    setSildOpen(false)
    setMinistate(false)
    if (collapsedSeenRef.current) return
    syncingNarrowCloseRef.current = true
    onAutoClose?.()
  }

  useEffect(() => {
    if (window.innerWidth <= DESKTOP_BREAKPOINT) closeNarrowSidebar()
  }, [])

  useEffect(() => {
    if (window.innerWidth <= DESKTOP_BREAKPOINT) closeNarrowSidebar()
  }, [pathName])

  useEffect(() => {
    const handleResize = () => {
      const isNarrow = window.innerWidth <= DESKTOP_BREAKPOINT
      setNarrow(isNarrow)
      setMenuEvent(!isNarrow)
      if (isNarrow) {
        closeNarrowSidebar()
        return
      }
      setSildOpen(!preferMiniRef.current)
      if (preferMiniRef.current) onAutoClose?.()
      else onAutoOpen?.()
    }

    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [onAutoClose, onAutoOpen])

  const onOpenminitab_management = () => {
    getPermissionAdmin()
    setPathActive('/management')
    setMinistate(!ministate)
  }

  // page show
  const [projectlist, setProjecylist] = useState(true)
  const [taskinbox, setTaskinbox] = useState(true)
  const [professional, setProfressional] = useState(true)
  const [helpdesk, setHelpdesk] = useState(true)
  const [management, setManagement] = useState(false)
  const [summary, setSummary] = useState(true)
  const [historyInbox, setHistory] = useState(false)
  const [menuAnalytics, setMenuAnalytics] = useState(true)
  //Unsave change
  const [visibleSaveChange, setVisibleSaveChange] = useState(false)
  const [path_admin, setPath_admin] = useState('')
  const [hiddenMenu, setHiddenMenu] = useState({
    unit: true,
    company: true,
    projectgroup: true,
    holiday: true,
    impact: true,
    support: true,
    professional: true,
    business: true,
    businessUnit: true,
    authADFS: true,
    kpi: true,
    user: true,
    role: true,
    powerBI: true,
    benefit: true,
    mainProfessionalSkills: true,
    mainAnalytics: true,
    mainYourProject: true,
    mainAllProject: true,
    mainYourTaskBox: true,
    mainAllTaskBox: true,
    mainSummary: true,
    mainExecutive: true,
  })
  const roleUser = getCookie('roleUser')
  const [ministate, setMinistate] = useState(false)
  const area_manage_tab = useRef(null)
  const area_btn_management = useRef(null)
  const [stylesfocus, setStylesfocus] = useState(true)
  const [focus, setFocus] = useState(1)

  useEffect(() => {
    setHistory(false)
    let showManagement = false

    adminPermission?.map((item) => {
      if (item.menu_code?.startsWith('adm_') && item.read == 'Y') {
        showManagement = true
      }
      if (item.menu_code == 'hme_taskhtry') {
        setHistory(true)
      }
    })

    if (roleUser == 1) {
      showManagement = true
    }

    setManagement(showManagement)
  }, [adminPermission])

  useEffect(() => {
    if (roleUser == 1) {
      setHiddenMenu((prevState) => ({
        ...prevState,
        unit: false,
        company: false,
        projectgroup: false,
        holiday: false,
        impact: false,
        support: false,
        professional: false,
        business: false,
        businessUnit: false,
        authADFS: false,
        kpi: false,
        user: false,
        role: false,
        powerBI: false,
        benefit: false,
        mainProfessionalSkills: false,
        mainAnalytics: false,
        mainYourProject: false,
        mainAllProject: false,
        mainYourTaskBox: false,
        mainAllTaskBox: false,
        mainSummary: false,
        mainExecutive: false,
      }))
    } else {
      setHiddenMenu((prevState) => ({
        ...prevState,
        unit: true,
        company: true,
        projectgroup: true,
        holiday: true,
        impact: true,
        support: true,
        professional: true,
        business: true,
        businessUnit: true,
        authADFS: true,
        kpi: true,
        user: true,
        role: true,
        powerBI: true,
        benefit: true,
        mainProfessionalSkills: true,
        mainAnalytics: true,
        mainYourProject: true,
        mainAllProject: true,
        mainYourTaskBox: true,
        mainAllTaskBox: true,
        mainSummary: true,
        mainExecutive: true,
      }))
    }
    adminPermission?.map((item) => {
      item.menu_code == 'hme_proj'
        ? item.read == 'Y'
          ? setHiddenMenu((prevState) => ({
            ...prevState,
            mainYourProject: false,
          }))
          : setHiddenMenu((prevState) => ({
            ...prevState,
            mainYourProject: true,
          }))
        : _
      item.menu_code == 'hme_projall'
        ? item.read == 'Y'
          ? setHiddenMenu((prevState) => ({
            ...prevState,
            mainAllProject: false,
          }))
          : setHiddenMenu((prevState) => ({
            ...prevState,
            mainAllProject: true,
          }))
        : _
      item.menu_code == 'hme_task'
        ? item.read == 'Y'
          ? setHiddenMenu((prevState) => ({
            ...prevState,
            mainYourTaskBox: false,
          }))
          : setHiddenMenu((prevState) => ({
            ...prevState,
            mainYourTaskBox: true,
          }))
        : _
      item.menu_code == 'hme_taskall'
        ? item.read == 'Y'
          ? setHiddenMenu((prevState) => ({
            ...prevState,
            mainAllTaskBox: false,
          }))
          : setHiddenMenu((prevState) => ({
            ...prevState,
            mainAllTaskBox: true,
          }))
        : _
      item.menu_code == 'hme_dasb'
        ? item.read == 'Y'
          ? setHiddenMenu((prevState) => ({
            ...prevState,
            mainSummary: false,
          }))
          : setHiddenMenu((prevState) => ({
            ...prevState,
            mainSummary: true,
          }))
        : _
      item.menu_code == 'hme_dasball'
        ? item.read == 'Y'
          ? setHiddenMenu((prevState) => ({
            ...prevState,
            mainExecutive: false,
          }))
          : setHiddenMenu((prevState) => ({
            ...prevState,
            mainExecutive: true,
          }))
        : _
      item.menu_code == 'hme_profsk'
        ? item.read == 'Y'
          ? setHiddenMenu((prevState) => ({
            ...prevState,
            mainProfessionalSkills: false,
          }))
          : setHiddenMenu((prevState) => ({
            ...prevState,
            mainProfessionalSkills: true,
          }))
        : _
      item.menu_code == 'hme_powbi'
        ? item.read == 'Y'
          ? setHiddenMenu((prevState) => ({
            ...prevState,
            mainAnalytics: false,
          }))
          : setHiddenMenu((prevState) => ({
            ...prevState,
            mainAnalytics: true,
          }))
        : _
      item.menu_code == 'adm_unit'
        ? item.read == 'Y'
          ? setHiddenMenu((prevState) => ({
            ...prevState,
            unit: false,
          }))
          : setHiddenMenu((prevState) => ({
            ...prevState,
            unit: true,
          }))
        : _
      item.menu_code == 'adm_com'
        ? item.read == 'Y'
          ? setHiddenMenu((prevState) => ({
            ...prevState,
            company: false,
          }))
          : setHiddenMenu((prevState) => ({
            ...prevState,
            company: true,
          }))
        : _
      item.menu_code == 'adm_group'
        ? item.read == 'Y'
          ? setHiddenMenu((prevState) => ({
            ...prevState,
            projectgroup: false,
          }))
          : setHiddenMenu((prevState) => ({
            ...prevState,
            projectgroup: true,
          }))
        : _
      item.menu_code == 'adm_hol'
        ? item.read == 'Y'
          ? setHiddenMenu((prevState) => ({
            ...prevState,
            holiday: false,
          }))
          : setHiddenMenu((prevState) => ({
            ...prevState,
            holiday: true,
          }))
        : _
      item.menu_code == 'adm_impact'
        ? item.read == 'Y'
          ? setHiddenMenu((prevState) => ({
            ...prevState,
            impact: false,
          }))
          : setHiddenMenu((prevState) => ({
            ...prevState,
            impact: true,
          }))
        : _
      item.menu_code == 'adm_supp'
        ? item.read == 'Y'
          ? setHiddenMenu((prevState) => ({
            ...prevState,
            support: false,
          }))
          : setHiddenMenu((prevState) => ({
            ...prevState,
            support: true,
          }))
        : _
      item.menu_code == 'adm_profsk'
        ? item.read == 'Y'
          ? setHiddenMenu((prevState) => ({
            ...prevState,
            professional: false,
          }))
          : setHiddenMenu((prevState) => ({
            ...prevState,
            professional: true,
          }))
        : _
      item.menu_code == 'adm_buss'
        ? item.read == 'Y'
          ? setHiddenMenu((prevState) => ({
            ...prevState,
            business: false,
          }))
          : setHiddenMenu((prevState) => ({
            ...prevState,
            business: true,
          }))
        : _
      item.menu_code == 'adm_kpi'
        ? item.read == 'Y'
          ? setHiddenMenu((prevState) => ({
            ...prevState,
            kpi: false,
          }))
          : setHiddenMenu((prevState) => ({
            ...prevState,
            kpi: true,
          }))
        : _
      item.menu_code == 'adm_user'
        ? item.read == 'Y'
          ? setHiddenMenu((prevState) => ({
            ...prevState,
            user: false,
          }))
          : setHiddenMenu((prevState) => ({
            ...prevState,
            user: true,
          }))
        : _
      item.menu_code == 'adm_role'
        ? item.read == 'Y'
          ? setHiddenMenu((prevState) => ({
            ...prevState,
            role: false,
          }))
          : setHiddenMenu((prevState) => ({
            ...prevState,
            role: true,
          }))
        : _
      item.menu_code == 'adm_powbi'
        ? item.read == 'Y'
          ? setHiddenMenu((prevState) => ({
            ...prevState,
            powerBI: false,
          }))
          : setHiddenMenu((prevState) => ({
            ...prevState,
            powerBI: true,
          }))
        : _
      item.menu_code == 'adm_adfs'
        ? item.read == 'Y'
          ? setHiddenMenu((prevState) => ({
            ...prevState,
            authADFS: false,
          }))
          : setHiddenMenu((prevState) => ({
            ...prevState,
            authADFS: true,
          }))
        : _
      item.menu_code == 'hme_projadm'
        ? item.read == 'Y'
          ? setHiddenMenu((prevState) => ({
            ...prevState,
            mainAllProject: false,
          }))
          : setHiddenMenu((prevState) => ({
            ...prevState,
            mainAllProject: true,
          }))
        : _
      item.menu_code == 'adm_benefit'
        ? item.read == 'Y'
          ? setHiddenMenu((prevState) => ({
            ...prevState,
            benefit: false,
          }))
          : setHiddenMenu((prevState) => ({
            ...prevState,
            benefit: true,
          }))
        : _
      item.menu_code == "adm_sync_business"
        ? item.read == 'Y'
          ? setHiddenMenu((prevState) => ({
            ...prevState,
            businessUnit: false,
          }))
          : setHiddenMenu((prevState) => ({
            ...prevState,
            businessUnit: true,
          }))
        : _
    })
  }, [adminPermission])

  const renderMenuInManagement = () => {
    return (
      menuEvent && (
        <div style={{ display: 'flex', flexDirection: 'row' }}>
          <Minimenu
            className={
              sildOpen
                ? ministate
                  ? 'minimenu-custom-normal'
                  : 'minimenu-custom-active'
                : ministate
                  ? 'minimenu-custom-normal2'
                  : 'minimenu-custom-active2'
            }
            ref={area_manage_tab}
          >
            <Row
              hidden={hiddenMenu.unit}
              id="unit"
              className={
                stylesfocus && focus == 1
                  ? 'area-sub-minimenu-normal'
                  : 'area-sub-minimenu-active'
              }
              onClick={() => renderSub_components_management(1, 'unitmeasurement')}
            >
              <DollarOutlined className="icon" />
              <p>Unit measurement</p>
            </Row>
            <Row
              hidden={hiddenMenu.company}
              id="company"
              className={
                stylesfocus && focus == 2
                  ? 'area-sub-minimenu-normal'
                  : 'area-sub-minimenu-active'
              }
              onClick={() => renderSub_components_management(2, 'company')}
            >
              <ControlOutlined className="icon" />
              <p>Business/Operation/Project type</p>
            </Row>
            <Row
              hidden={hiddenMenu.projectgroup}
              id="group"
              className={
                stylesfocus && focus == 3
                  ? 'area-sub-minimenu-normal'
                  : 'area-sub-minimenu-active'
              }
              onClick={() => renderSub_components_management(3, 'group')}
            >
              <FolderOpenOutlined className="icon" />
              <p>Strategic Perspective/Direction/Imperative</p>
            </Row>
            <Row
              hidden={hiddenMenu.holiday}
              id="holiday"
              className={
                stylesfocus && focus == 4
                  ? 'area-sub-minimenu-normal'
                  : 'area-sub-minimenu-active'
              }
              onClick={() => renderSub_components_management(4, 'holiday')}
            >
              <CalendarOutlined className="icon" />
              <p>Holiday</p>
            </Row>
            <Row
              hidden={hiddenMenu.impact}
              id="impact"
              className={
                stylesfocus && focus == 5
                  ? 'area-sub-minimenu-normal'
                  : 'area-sub-minimenu-active'
              }
              onClick={() => renderSub_components_management(5, 'impact')}
            >
              <AimOutlined className="icon" />
              <p>Stage</p>
            </Row>
            <Row
              id="support"
              hidden={hiddenMenu.support}
              className={
                stylesfocus && focus == 6
                  ? 'area-sub-minimenu-normal'
                  : 'area-sub-minimenu-active'
              }
              onClick={() => renderSub_components_management(6, 'support')}
            >
              <ToolOutlined className="icon" />
              <p>Support Category</p>
            </Row>
            <Row
              hidden={hiddenMenu.professional}
              id="professional"
              className={
                stylesfocus && focus == 7
                  ? 'area-sub-minimenu-normal'
                  : 'area-sub-minimenu-active'
              }
              onClick={() => renderSub_components_management(7, 'professional')}
            >
              <StarOutlined className="icon" />
              <p>Professional Skills</p>
            </Row>
            <Row
              hidden={hiddenMenu.business}
              id="business"
              className={
                stylesfocus && focus == 8
                  ? 'area-sub-minimenu-normal'
                  : 'area-sub-minimenu-active'
              }
              onClick={() => renderSub_components_management(8, 'business')}
            >
              <ShoppingOutlined className="icon" />
              <p>Business Group</p>
            </Row>
            <Row
              hidden={hiddenMenu.businessUnit}
              id="businessUnit"
              className={
                stylesfocus && focus == 15
                  ? 'area-sub-minimenu-normal'
                  : 'area-sub-minimenu-active'
              }
              onClick={() => renderSub_components_management(15, 'business-unit')}
            >
              <ShoppingOutlined className="icon" />
              <p>Business Unit</p>
            </Row>
            <Row
              hidden={hiddenMenu.kpi}
              id="kpi"
              className={
                stylesfocus && focus == 9
                  ? 'area-sub-minimenu-normal'
                  : 'area-sub-minimenu-active'
              }
              onClick={() => renderSub_components_management(9, 'kpi')}
            >
              <DashboardOutlined className="icon" />
              <p>KPI/Finance Type</p>
            </Row>

            <Row
              hidden={hiddenMenu.benefit}
              id="benefit"
              className={
                stylesfocus && focus == 10
                  ? 'area-sub-minimenu-normal'
                  : 'area-sub-minimenu-active'
              }
              onClick={() => renderSub_components_management(10, 'benefit')}
            >
              <ProductOutlined className="icon" />
              <p>Benefit Type</p>
            </Row>
            <Row
              hidden={hiddenMenu.user}
              id="user"
              className={
                stylesfocus && focus == 11
                  ? 'area-sub-minimenu-normal'
                  : 'area-sub-minimenu-active'
              }
              onClick={() => renderSub_components_management(11, 'user')}
            >
              <IdcardOutlined className="icon" />
              <p>User Management</p>
            </Row>
            <Row
              hidden={hiddenMenu.role}
              id="role"
              className={
                stylesfocus && focus == 12
                  ? 'area-sub-minimenu-normal'
                  : 'area-sub-minimenu-active'
              }
              onClick={() => renderSub_components_management(12, 'role')}
            >
              <ScheduleOutlined className="icon" />
              <p>Role and Permission</p>
            </Row>
            <Row
              hidden={hiddenMenu.powerBI}
              id="role"
              className={
                stylesfocus && focus == 13
                  ? 'area-sub-minimenu-normal'
                  : 'area-sub-minimenu-active'
              }
              onClick={() => renderSub_components_management(13, 'powerbi')}
            >
              <AuditOutlined className="icon" />
              <p>Power BI</p>
            </Row>
            <Row
              hidden={hiddenMenu.authADFS}
              id="authADFS"
              className={
                stylesfocus && focus == 14
                  ? 'area-sub-minimenu-normal'
                  : 'area-sub-minimenu-active'
              }
              onClick={() => renderSub_components_management(14, 'authADFS')}
            >
              <FormOutlined className="icon" />
              <p>Custom Auth ADFS</p>
            </Row>
          </Minimenu>
        </div>
      )
    )
  }
  const renderMenuList_summary = () => {
    if (summary === true) {
      return (
        <Link
          hidden={hiddenMenu.mainSummary && hiddenMenu.mainExecutive ? true : false}
          to={!isDirty ? '/dashboard' : _}
          style={{ textDecoration: 'none' }}
          className={
            pathActive === '/dashboard' ? 'side-menu-item-active' : 'side-menu-item'
          }
          title={sildOpen ? undefined : word['Summary']}
          key={'/dashboard'}
          onClick={() => {
            !isDirty ? setPathActive('/dashboard') : _,
              isDirty ? setVisibleSaveChange(true) : _,
              setClick_path('/dashboard')
          }}
        >
          <img
            className="side-menu-icon"
            src={pathActive === '/dashboard' ? summaryBlue : summary_white}
          />
          {sildOpen && (
            <div
              className={
                pathActive === '/dashboard' ? 'text-primary-blue ' : 'text-white '
              }
            >
              {word['Summary']}
            </div>
          )}
        </Link>
      )
    }
  }
  const renderMenuList_projectlist = () => {
    if (projectlist === true) {
      return (
        <Link
          hidden={hiddenMenu.mainAllProject && hiddenMenu.mainYourProject ? true : false}
          to={!isDirty ? '/project-list' : _}
          style={{ textDecoration: 'none' }}
          className={
            pathActive === '/project-list' ? 'side-menu-item-active' : 'side-menu-item'
          }
          title={sildOpen ? undefined : word['Project_List']}
          key={'/project-list'}
          onClick={() => {
            !isDirty ? setPathActive('/project-list') : _,
              isDirty ? setVisibleSaveChange(true) : _,
              isDirty ? setClick_path('/project-list') : setClick_path()
          }}
        >
          <img
            className="side-menu-icon"
            src={pathActive === '/project-list' ? projectlistBlue : projectlistwhite}
          />
          {sildOpen && (
            <div
              className={
                pathActive === '/project-list' ? 'text-primary-blue' : 'text-white'
              }
            >
              {word['Project_List']}
            </div>
          )}
        </Link>
      )
    }
  }
  const renderMenulist_taskinbox = () => {
    if (taskinbox === true) {
      return (
        <Link
          hidden={hiddenMenu.mainAllTaskBox && hiddenMenu.mainYourTaskBox ? true : false}
          to={!isDirty ? '/taskinbox' : _}
          style={{ textDecoration: 'none' }}
          className={
            pathActive === '/taskinbox' ? 'side-menu-item-active' : 'side-menu-item'
          }
          title={sildOpen ? undefined : word['Task_Inbox']}
          key={'/taskinbox'}
          onClick={() => {
            !isDirty ? setPathActive('/taskinbox') : _,
              isDirty ? setVisibleSaveChange(true) : _,
              isDirty ? setClick_path('/taskinbox') : setClick_path()
          }}
        >
          <img
            className="side-menu-icon"
            src={pathActive === '/taskinbox' ? taskinboxBlue : taskinboxwhite}
          />
          {sildOpen && (
            <div
              className={pathActive === '/taskinbox' ? 'text-primary-blue' : 'text-white'}
            >
              {word['Task_Inbox']}
            </div>
          )}
        </Link>
      )
    }
  }
  const renderMenulist_professional = () => {
    if (professional === true) {
      return (
        <Link
          hidden={hiddenMenu.mainProfessionalSkills}
          to={!isDirty ? '/professional-skills' : _}
          style={{ textDecoration: 'none' }}
          className={
            pathActive === '/professional-skills'
              ? 'side-menu-item-active'
              : 'side-menu-item'
          }
          title={sildOpen ? undefined : word['Professional_skills']}
          key={'/professional-skills'}
          onClick={() => {
            !isDirty ? setPathActive('/professional-skills') : _,
              isDirty ? setVisibleSaveChange(true) : _,
              isDirty ? setClick_path('/professional-skills') : setClick_path()
          }}
        >
          <img
            className="side-menu-icon"
            src={pathActive === '/professional-skills' ? proskillBlue : proskill2}
          />
          {sildOpen && (
            <div
              className={
                pathActive === '/professional-skills'
                  ? 'text-primary-blue '
                  : 'text-white '
              }
            >
              {word['Professional_skills']}
            </div>
          )}
        </Link>
      )
    }
  }
  const renderMenulist_analytics = () => {
    if (menuAnalytics === true) {
      return (
        <Link
          hidden={hiddenMenu.mainAnalytics}
          style={{ textDecoration: 'none' }}
          className={
            pathActive === '/data-analytics' ? 'side-menu-item-active' : 'side-menu-item'
          }
          title={sildOpen ? undefined : word['Data_Analytics']}
          key={'/data-analytics'}
          onClick={() => {
            !isDirty ? setPathActive('/data-analytics') : _,
              isDirty ? setVisibleSaveChange(true) : _,
              isDirty ? setClick_path('/data-analytics') : setClick_path()
          }}
          to={!isDirty ? '/data-analytics' : _}
        >
          <img
            className="side-menu-icon"
            src={pathActive === '/data-analytics' ? analyticsBlue : analyticswhite}
          />
          {sildOpen && (
            <div
              className={
                pathActive === '/data-analytics' ? 'text-primary-blue' : 'text-white'
              }
            >
              {word['Data_Analytics']}
            </div>
          )}
        </Link>
      )
    }
  }

  const renderMenulist_management = () => {
    if (management === true) {
      return (
        <div
          id="btn-tab-management"
          className={
            pathActive === '/management' ? 'side-menu-item-active' : 'side-menu-item'
          }
          title={sildOpen ? undefined : word['Management']}
          key={'/management'}
          onClick={() => {
            onOpenminitab_management()
          }}
          ref={area_btn_management}
        >
          <img
            className="side-menu-icon"
            src={pathActive === '/management' ? adminBlue : adminwhite}
          />
          {sildOpen && (
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                width: '100%',
                justifyContent: 'space-between',
              }}
            >
              <p
                className={
                  pathActive === '/management' ? 'text-primary-blue ' : 'text-white '
                }
              >
                {word['Management']}
              </p>
              {ministate ? <LeftOutlined /> : <RightOutlined />}
            </div>
          )}
        </div>
      )
    }
  }
  const renderMenuList_history = () => {
    if (historyInbox === true) {
      return (
        <Link
          // hidden={hiddenMenu.mainAllTaskBox && hiddenMenu.mainYourTaskBox ? true : false}
          to={!isDirty ? '/historyInbox' : _}
          style={{ textDecoration: 'none' }}
          className={
            pathActive === '/historyInbox' ? 'side-menu-item-active' : 'side-menu-item'
          }
          title={sildOpen ? undefined : word['History']}
          key={'/historyInbox'}
          onClick={() => {
            !isDirty ? setPathActive('/historyInbox') : _,
              isDirty ? setVisibleSaveChange(true) : _,
              isDirty ? setClick_path('/historyInbox') : setClick_path()
          }}
        >
          <img
            className="side-menu-icon"
            src={pathActive === '/historyInbox' ? historyIconBlue : historyIconwhite}
          />
          {sildOpen && (
            <div
              className={
                pathActive === '/historyInbox' ? 'text-primary-blue' : 'text-white'
              }
            >
              {word['History']}
            </div>
          )}
        </Link>
      )
    }
  }

  const renderMenuList_helpdesk = () => {
    if (helpdesk === true) {
      if (isMobielView) {
        return (
          <Link
            style={{
              display: !sildOpen && 'none',
              position: 'fixed',
              bottom: '130px',
              borderTop: '2px solid rgb(228 231 236)',
              padding: '15px 0px 17px 24px',
            }}
            to={!isDirty ? '/helpdesk' : _}
            className={
              pathActive === '/helpdesk' ? 'side-menu-item-active' : 'side-menu-item'
            }
            key={'/helpdesk'}
            onClick={() => {
              !isDirty ? setPathActive('/helpdesk') : _,
                isDirty ? setVisibleSaveChange(true) : _,
                isDirty ? setClick_path('/helpdesk') : setClick_path()
            }}
          >
            <img
              className="side-menu-icon"
              src={pathActive === '/helpdesk' ? CallCenterIconBlue : CallCenterIconWhite}
            />
            {sildOpen && (
              <div className={pathActive === '/helpdesk' ? 'text-primary-blue' : 'text-white'}>
                {word['HelpDesk']}
              </div>
            )}
          </Link>
        )
      } else {
        return (
          <Link
            style={{
              position: 'fixed',
              bottom: '130px',
              borderTop: '2px solid rgb(228 231 236)',
              padding: '15px 0px 17px 24px',
            }}
            to={!isDirty ? '/helpdesk' : _}
            className={
              pathActive === '/helpdesk' ? 'side-menu-item-active' : 'side-menu-item'
            }
            title={sildOpen ? undefined : word['HelpDesk']}
            key={'/helpdesk'}
            onClick={() => {
              !isDirty ? setPathActive('/helpdesk') : _,
                isDirty ? setVisibleSaveChange(true) : _,
                isDirty ? setClick_path('/helpdesk') : setClick_path()
            }}
          >
            <img
              className="side-menu-icon"
              src={pathActive === '/helpdesk' ? CallCenterIconBlue : CallCenterIconWhite}
            />
            {sildOpen && (
              <div className={pathActive === '/helpdesk' ? 'text-primary-blue' : 'text-white'}>
                {word['HelpDesk']}
              </div>
            )}
          </Link>
        )
      }
    }
  }
  const onLogout = () => {
    try {
      dispatch({
        type: UserActionTypes.LOGOUT_SUCCESS,
        payload: '',
      })
      removeCookieAll()
      _refiner('resetUser')
      window.location.href = LOGIN_AXONS_ONE ? '/v2/login' : '/login'
    } catch (error) {
      console.log(error)
    }
  }

  const renderLogout = () => {
    if (isMobielView) {
      return (
        <Link
          style={{
            display: !sildOpen && 'none',
            position: 'fixed',
            bottom: '70px',
            padding: '17px 0px 17px 24px',
          }}
          className={'side-menu-item'}
          onClick={() => onLogout()}
        >
          <img className="side-menu-icon" src={logoutIconWhite} />
          {sildOpen && <div className={'text-white'}>{word['log_out']}</div>}
        </Link>
      )
    } else {
      return (
        <Link
          style={{
            position: 'fixed',
            bottom: '70px',
            padding: '17px 0px 17px 24px',
          }}
          className={'side-menu-item'}
          title={sildOpen ? undefined : word['log_out']}
          onClick={() => onLogout()}
        >
          <img className="side-menu-icon" src={logoutIconWhite} />
          {sildOpen && <div className={'text-white'}>{word['log_out']}</div>}
        </Link>
      )
    }
  }

  const renderSub_components_management = (value, path) => {
    setFocus(value)
    if (isDirty) {
      setClick_path(`/management/${path}`)
      setVisibleSaveChange(true)
    } else {
      if (value == 1) {
        history.push('/management/unitmeasurement')
      } else if (value == 2) {
        history.push('/management/company')
      } else if (value == 3) {
        history.push('/management/group')
      } else if (value == 4) {
        history.push('/management/holiday')
      } else if (value == 5) {
        history.push('/management/impact')
      } else if (value == 6) {
        history.push('/management/support')
      } else if (value == 7) {
        history.push('/management/professional')
      } else if (value == 8) {
        history.push('/management/business')
      } else if (value == 9) {
        history.push('/management/kpi')
      } else if (value == 10) {
        history.push('/management/benefit')
      } else if (value == 11) {
        history.push('/management/user')
      } else if (value == 12) {
        history.push('/management/role')
      } else if (value == 13) {
        history.push('/management/powerbi')
      } else if (value == 14) {
        history.push('/management/authADFS')
      } else if (value == 15) {
        history.push('/management/business-unit')
      }
    }

    setMinistate(false)
  }

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        area_btn_management.current &&
        !area_btn_management.current.contains(event.target)
      ) {
        if (area_manage_tab.current && !area_manage_tab.current.contains(event.target)) {
          setMinistate(false)
        } else {
          setMinistate(true)
        }
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [area_manage_tab])

  return (
    <SliderWrapper useMargin={(e) => useMargin}>
      <div
        className={
          sildOpen ? 'main-side-bar' : narrow ? 'main-side-close-phone' : 'main-side-close'
        }
      >
        {sildOpen && <div className="text-haed-tab"> Main Menu</div>}
        {renderMenuList_summary()}
        {renderMenuList_projectlist()}
        {MENU_INBOX_VISIBLE && renderMenulist_taskinbox()}
        {MENU_HISTORY_VISIBLE && renderMenuList_history()}
        {MENU_PROFESSIONAL_SKILL_VISIBLE && renderMenulist_professional()}
        {renderMenulist_analytics()}
        {renderMenulist_management()}
        {renderMenuList_helpdesk()}
        {renderLogout()}
      </div>
      {renderMenuInManagement()}
      <ModalSaveChange
        form={form}
        visibleSaveChange={visibleSaveChange}
        setVisibleSaveChange={setVisibleSaveChange}
        path={click_path}
        setClick_path={setClick_path}
        state={'menu'}
      />
    </SliderWrapper>
  )
}

export default CustomSlider
